import { render, staticRenderFns } from "./BinocularsSvg.vue?vue&type=template&id=0f3aa69c&"
import script from "./BinocularsSvg.vue?vue&type=script&lang=ts&"
export * from "./BinocularsSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports